import React from 'react';

import ManageIslandsWizard from '../island/manage-islands-wizard/Index';

const Islands = (): React.ReactElement => (
  <ManageIslandsWizard />
);

export default Islands;
